import PdpDropdownModal from './PdpDropdownModal';
import PdpDropdownGroupModal from './PdpDropdownGroupModal';
export default class PdpMultiSelectModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            modifiersList: [],
            localMultiSelectIds: this.props.getlocalMultiSelectIds(),
            localModifierList: {},
            isChildSelected: false,
            DropdownDetails: {
                DropDownEntries: [],
                DropDownName: ''
            },
            calTexts: '',
            //errorImg: this.props.errorImg || "https://qa2.applebees.com/-/media/Applebees2/Images/Menu/Default%20Images/Modifier-Placeholder?la=en&hash=89A5226BCA63C6735C23124399CA6638"
            errorImg: this.props.errorImg

        };
        this.handleMultiChange = this.handleMultiChange.bind(this);
        this.getCalorieText = this.getCalorieText.bind(this);
        this.isEmpty = this.isEmpty.bind(this);
        this.filterDropDownInOption = this.filterDropDownInOption.bind(this);

    }

    handleImageError(e) {
        e.target.onerror = null
        e.persist();
        e.target.src = this.state.errorImg
    }
    getSubstituteOptionGroupName(optionGroups) {
        let name;
        if (optionGroups.length > 0) {
            name = optionGroups[0].GroupedName;
        }
        return name;
    }
    getReqiuredStatus(option) {
        let returnText = "optional";
        let className = "";
        let count = 0, selectedChildCount = 0;
        if (option.IsRequired == true) {
            returnText = "Required";
            if (this.props.data.length > 0) {
                this.props.data.map(item => {
                    selectedChildCount = this.getAllSelectedChildCount(item.value);

                    if ($(".accordion-body." + item.id).hasClass("comp-3") != true) {
                        if (this.state.localMultiSelectIds.indexOf(item.value) > -1 || selectedChildCount != 0) { count++; }
                    } else {
                        if (this.state.localMultiSelectIds.indexOf(item.value) > -1 && selectedChildCount != 0) { count++; }
                    }

                })
            }
            if (option.IsRequired == true && count >= option.minselects) {
                returnText = "completed";
                className = "showBold completed";
            }
        }
        let resp = {
            "text": returnText,
            "className": className
        }

        return resp;
    }
    getExtraPrice(modifiers) {
        let price;
        modifiers.map(modifier => {
            if (modifier.MenuItemDetail.Name == "Extra") {
                price = modifier.MenuItemDetail.Price;
            }
        });
        return price;
    }

    isEmpty(obj) {
        for (const prop in obj) {
            if (Object.hasOwn(obj, prop)) {
                return false;
            }
        }
        return true;
    }
    getAllSelectedChildNameWithSub(id, name) {
        let selectedObj = this.props.getAllselectedChildModifiers(this.props.parentModifierId, id, true);
        name = name || [];
        let getlocalMultiSelectIds = this.props.getlocalMultiSelectIds();
        if (selectedObj.length > 0) {
            selectedObj.map(obj => {
                if (getlocalMultiSelectIds.indexOf(obj.value) != -1) {
                    name.push(obj.label);
                    this.getAllSelectedChildNameWithSub(obj.value, name)
                }

            })
        }
        return name;
    }

    getAllSelectedChildName(id, label) {
        let selectedObj = this.props.getAllselectedChildModifiers(this.props.parentModifierId, id, true);
        let name = [];
        let getlocalMultiSelectIds = this.props.getlocalMultiSelectIds();
        selectedObj.map(obj => {
            if (getlocalMultiSelectIds.indexOf(obj.value) != -1)
                name.push(obj.label);
        })
        return name;
    }
    getAllSelectedChildCount(id) {
        let selectedObj = this.props.getAllselectedChildModifiers(this.props.parentModifierId, id, true);
        let count = 0;
        let getlocalMultiSelectIds = this.props.getlocalMultiSelectIds();
        selectedObj.map(obj => {
            if (getlocalMultiSelectIds.indexOf(obj.value) != -1) count++;
        })
        return count;
    }
    getAllSelectedSubChildName(id, label) {
        let selectedObj = this.props.getAllselectedChildModifiers(this.props.parentModifierId, id, true);
        let name = [];
        let getlocalMultiSelectIds = this.props.getlocalMultiSelectIds();
        selectedObj.map(obj => {
            let selectedSubObj = this.props.getAllselectedChildModifiers(this.props.parentModifierId, obj.value, true);
            selectedSubObj.map(item => {
                if (getlocalMultiSelectIds.indexOf(obj.value) != -1)
                    name.push(item.label);
            })

        })
        return name;
    }
    getAllSelectedChildPrice(id, price, ComponentDisplay) {
        let totalPrice = 0;
        let isSubstitute = (ComponentDisplay == 7) ? true : false;
        if (ComponentDisplay == 7 || ComponentDisplay == 4 || ComponentDisplay == 2 || ComponentDisplay == 1 || ComponentDisplay == 5) {
            let selectedObj = this.props.getAllselectedChildModifiers(this.props.parentModifierId, id, true);
            let getlocalMultiSelectIds = this.props.getlocalMultiSelectIds();
            if (selectedObj.length > 0) {
                if (isSubstitute != true) totalPrice = price;
                selectedObj.map(obj => {
                    if (getlocalMultiSelectIds.indexOf(obj.value) != -1)
                        totalPrice = totalPrice + obj.price;
                })
            } else {
                totalPrice = price;
            }
        } else {
            totalPrice = price;
        }

        totalPrice = "$" + parseFloat(totalPrice).toFixed(2);

        return totalPrice;
    }

    getAllSelectedChildCalories(id, cm, ComponentDisplay) {
        let baseCal = 0;

        let isSubstitute = (ComponentDisplay == 7) ? true : false;
        if (ComponentDisplay == 7 || ComponentDisplay == 6) {
            let selectedObj = this.getLocallySelectedChildren(id);

            if (selectedObj.length > 0) {
                if (isSubstitute != true) baseCal = cm;
                if (baseCal == null) baseCal = 0;
                selectedObj.map(obj => {
                    baseCal = parseInt(baseCal) + parseInt(obj.baseCal);
                })
            } else {
                baseCal = cm;
            }
        } else {
            baseCal = cm;
        }
        if (baseCal == 0) {
            return "";
        }
        let res = (baseCal > 0 ? this.props.CalorieAdds + " " + baseCal :
            (baseCal < 0 ? this.props.CalorieSubtracts + " " + (-1 * baseCal) : "0")) + " " + this.props.CalorieAbbr;
        return res;
    }
    handleTileClick(option, maxSelect, id) {
        // Works like radio button.
       //console.log("allowed count = ", maxSelect)
        if (maxSelect == 1) {
            let PerivousSelectedID = this.props.parentGrpToCountMap.get(id);
            if (PerivousSelectedID != undefined && PerivousSelectedID.length > 0) {
                if (option.value != PerivousSelectedID[0]) {
                    $(".multiSelect-wrapper .accordion-body." + PerivousSelectedID[0]).click();
                }
            }
        }
        if (option.ComponentDisplay == 5) {
            let modi = (option.optionGroups[0] != undefined) ? option.optionGroups[0].Modifiers : null;
            this.handleSegmented(option, maxSelect, id, modi, "Remove");
        }
        else if (option.optionGroups.length == 0
            || option.ComponentDisplay == 0
            || option.ComponentDisplay == 8
            || option.ComponentDisplay == 3
            || option.ComponentDisplay == 1
            || option.ComponentDisplay == 7) {
            this.handleMultiChange(option, maxSelect, id);
        } else if (option.ComponentDisplay == 2) {
            let arr = JSON.parse(JSON.stringify(this.props.getlocalMultiSelectIds()));
            let childInarr = this.getLocallySelectedChildren(option.value);
            if (childInarr.length > 0 || arr.indexOf(option.value) > -1) {
                this.handleUnselect(option, maxSelect, id);
            } else {
                this.handleMultiChange(option, maxSelect, id);
                this.props.handleChange(option.value, option.label, maxSelect, id, option.ComponentDisplay);

            }

        } else if (option.ComponentDisplay == 4) {
            let arr = JSON.parse(JSON.stringify(this.props.getlocalMultiSelectIds()));
            let childInarr = this.getLocallySelectedChildren(option.value);
            if (childInarr.length > 0 || arr.indexOf(option.value) > -1) {
                this.handleUnselect(option, maxSelect, id);
            } else {
                this.handleMultiChange(option, maxSelect, id);
                this.props.handleChange(option.value, option.label, maxSelect, id, option.ComponentDisplay);
            }
        } else if (option.ComponentDisplay == 6) {
            let childInarr = this.getLocallySelectedChildren(option.value);
            if (childInarr.length == 0) {
               // this.handleMultiChange(option, maxSelect, id);
            }
        } else {
            this.handleUnselect(option, maxSelect, id);
        }
    }
    getLocallySelectedChildren(value) {
        let arr = JSON.parse(JSON.stringify(this.props.getlocalMultiSelectIds()));
        let selectedObj = this.props.getAllselectedChildModifiers(this.props.parentModifierId, value, true);
        let newArr = [];
        selectedObj.map(obj => {
            if (arr.indexOf(obj.value) > -1) {
                newArr.push(obj);
            }
        })
       //console.log("selectedObj", selectedObj, newArr)
        return newArr;
    }
    handleIconClick(option, maxSelect, id) {
        if (option.ComponentDisplay == 1) {
            this.handleSubChange(option, maxSelect, id);
        } else if (
            (option.ComponentDisplay == 4 || option.ComponentDisplay == 6) ||
            (option.ComponentDisplay != 0 && option.ComponentDisplay != 1 && option.ComponentDisplay != 2
                && option.ComponentDisplay != 3 && option.ComponentDisplay != 4 && option.ComponentDisplay != 8
                && option.ComponentDisplay != 7 && option.ComponentDisplay != 5)
        ) {
            this.handleMultiChange(option, maxSelect, id);

        } else {
            return false;
        }
    }
    getSubOptionName(value, label, ComponentDisplay) {
        let name = "";
        if (ComponentDisplay == 2) {
            name = this.getAllSelectedChildName(value).join(",");
        } else if (ComponentDisplay == 1) {
            name = this.getAllSelectedChildNameWithSub(value).join(",");
        }
        else if (ComponentDisplay == 7 || ComponentDisplay == 4) {
            name = this.getAllSelectedSubChildName(value, label).join(",");
        } 
        return name;
    }
    getOptionName(ModifierSlugName, ComponentDisplay, value, label) {
        let name = ModifierSlugName;
        if (ComponentDisplay == 7 || ComponentDisplay == 4 ) {
            let allnames = this.getAllSelectedChildName(value, label);

            if (allnames.length > 0) {
                name = allnames.join(",");
            } else {
                name = (ComponentDisplay == 7) ? ModifierSlugName : label;
            }
        }
        if (ComponentDisplay == 6) {
            let allnames = this.getAllSelectedChildNameWithSub(value);

            if (allnames.length > 0) {
                name = allnames.join(",");
            } else {
                name = label;
            }
        }
        return name;
    }
    getTileClass(option) {
        let optionClass = "";

        let localMultiSelectIds = this.props.getlocalMultiSelectIds();
        let additionalClass = " " + option.ComponentDisplay;
        if (option.ComponentDisplay == 7) {
            additionalClass = " substitute-body";
        }
        if (option.ComponentDisplay == 5 || option.ComponentDisplay == 1 || option.ComponentDisplay == 6) {
            additionalClass = " customize-body";
        }
        if ((localMultiSelectIds && localMultiSelectIds.indexOf(option.value) > -1 && option.ComponentDisplay != 8 && option.ComponentDisplay != 7 && option.ComponentDisplay != 5)
            || (option.ComponentDisplay == 8 && localMultiSelectIds.indexOf(option.value) < 0)
            || (option.ComponentDisplay == 7 && (localMultiSelectIds.indexOf(option.value) < 0 || this.getAllSelectedChildCount(option.value) > 0))
            || (option.ComponentDisplay != 0 && option.ComponentDisplay != 3 && option.ComponentDisplay != 8 && option.ComponentDisplay != 7 && option.ComponentDisplay != 5 &&
                this.checkAnyChildIsSelected(option.optionGroups))
            || (option.ComponentDisplay == 5 && option.optionGroups[0] != undefined && this.checkItemIsAdded(option.optionGroups[0].Modifiers, "Remove") != true)) {
            optionClass = "multiSelect-body accordion-body highlighter " + option.value + additionalClass;
        } else {
            optionClass = "multiSelect-body accordion-body " + option.value + additionalClass;

        }
        optionClass = optionClass + " comp-" + option.ComponentDisplay;
        return optionClass;
    }
    handleMultiChange(option, max, parentId) {
        let selectItem = {};
        selectItem.value = option.value;
        selectItem.label = option.label;
        selectItem.baseCal = option.BaseCalories;
        selectItem.price = option.CalcPrice;
        selectItem.image = option.ImagePath;
        selectItem.componentDisplay = option.ComponentDisplay;

        selectItem.parentModifierId = this.props.parentModifierId;
        selectItem.parentGroupId = parentId;
        selectItem.parentOptionGroupId = this.props.selectedoptionGroupId || this.props.parentModifierId;

        let cnt = 0;
        let buttonExtra = document.getElementById(option.value + "-checkClick");
        if (option.optionGroups.length == 0 || option.ComponentDisplay == 3 ||
            option.ComponentDisplay == 5 || option.ComponentDisplay == 7 ||
            option.ComponentDisplay == 1 || option.ComponentDisplay == 2
            || option.ComponentDisplay == 4) {
            let arr = JSON.parse(JSON.stringify(this.props.getlocalMultiSelectIds()));
            if (arr.indexOf(option.value) < 0) {

                if (this.props.checkMaxCount(option.value, max, parentId, 'add')) {
                    cnt = 1;
                    arr.push(option.value);
                    //let arrtype = (option.optionGroups.length > 0) ? "substitute" : "multi";
                    this.props.holdTempSelectedIds("substitute", selectItem);

                }
            } else {
                cnt = 1;
                let selectedObj = this.props.getAllselectedChildModifiers(this.props.parentModifierId, option.value, true);
                if (option.ComponentDisplay == 7) {
                    let childInarr = 0;
                    selectedObj.map(obj => {
                        if (arr.indexOf(obj.value) > -1) {
                            childInarr++;
                        }
                    })
                    if (selectedObj.length > 0 && childInarr > 0) {
                        this.removeAllNestedChild(selectedObj, arr);
                    }
                    else {
                        arr.splice(arr.indexOf(option.value), 1);
                        this.props.checkMaxCount(option.value, max, parentId, 'remove')
                        this.props.holdTempSelectedIds('substitute', selectItem);
                    }

                } else {
                    if (selectedObj.length > 0) {
                        ////console.log("substitute with Child object --->");
                        this.removeAllNestedChild(selectedObj, arr);
                    }
                    arr.splice(arr.indexOf(option.value), 1);
                    this.props.checkMaxCount(option.value, max, parentId, 'remove')
                    this.props.holdTempSelectedIds('substitute', selectItem);

                }

            }
            if (cnt == 1) {
                this.props.setlocalMultiSelectIds(arr);
                if (option.ComponentDisplay == 3) {
                    this.filterDropDownInOption(option.optionGroups);
                }
            } else {
                $(".btnsWrapper .pdp-error-display.alert-dismissible").removeClass("hidden").show().children('.alert-message').text(this.props.allData.MaxSelection);
            }

        } else {

            if (this.props.checkMaxCount(option.value, max, parentId, 'add', 'multi')) {
                this.props.handleChange(option.value, option.label, max, parentId, option.ComponentDisplay);
            } else {
                $(".btnsWrapper .pdp-error-display.alert-dismissible").removeClass("hidden").show().children('.alert-message').text(this.props.allData.MaxSelection);
            }
        }
    }
    handleSubChange(option, max, parentId) {
        if (this.props.checkMaxCount(option.value, max, parentId, 'add', 'multi')) {
            let title = option.label;
            if (option.ComponentDisplay == 7 || option.ComponentDisplay == 6) {
                title = this.getSubstituteOptionGroupName(option.optionGroups);
            }
            this.props.handleChange(option.value, title, max, parentId, option.ComponentDisplay);

        } else {
            $(".btnsWrapper .pdp-error-display.alert-dismissible").removeClass("hidden").show().children('.alert-message').text(this.props.allData.MaxSelection);
        }
    }
    checkAnyChildIsSelected(optionGroups, countdata) {
        let count = countdata || 0;
        let localMultiSelectIds = this.props.getlocalMultiSelectIds();
        optionGroups.map((optionGroup) => {
            optionGroup.Modifiers.map((groupmodifier) => {
                if (localMultiSelectIds.indexOf(groupmodifier.MenuItemDetail.Id) > -1) {
                    count++;
                } else {
                    if (groupmodifier.optionGroups.length > 0) {
                        count = this.checkAnyChildIsSelected(groupmodifier.optionGroups, count);
                    }
                }
            })
        })
        if (count > 0) {
            return true;
        } else return false;

    }

    filterDropDownInOption(optionGroups, modalDropDown) {
        let nextOptionGroupsInternl = [];
        let localMultiSelectIds = this.props.getlocalMultiSelectIds();
        let dropdownTitle = '';
        let arr = [];
        let DropdownDetails = {
            DropDownEntries: [],
            DropDownName: ''
        }
        if (optionGroups.length > 0) {
            optionGroups.map(optionGroup => {
                if (modalDropDown && modalDropDown == "modalDropdown") {
                    if (optionGroup.GroupDisplay == 1 && optionGroup.Id == this.props.id) {
                        optionGroup.Modifiers.map(optModifier => {
                            let optionvalue = {};
                            dropdownTitle = optionGroup.Name;
                            nextOptionGroupsInternl.push(optModifier);
                            optionvalue.label = optModifier.MenuItemDetail.Name;
                            optionvalue.value = optModifier.MenuItemDetail.Id;
                            optionvalue.ImagePath = optModifier.MenuItemDetail.ImagePath;
                            optionvalue.ModifierSlugName = optModifier.MenuItemDetail.ModifierSlugName;
                            optionvalue.BaseCalories = optModifier.MenuItemDetail.BaseCalories;
                            optionvalue.Price = optModifier.MenuItemDetail.Price;
                            optionvalue.CalcPrice = optModifier.MenuItemDetail.CalcPrice;
                            optionvalue.ComponentDisplay = optModifier.ComponentDisplay;
                            optionvalue.GroupDisplay = optionGroup.GroupDisplay;
                            if (localMultiSelectIds.includes(optModifier.MenuItemDetail.Id)) {
                                optionvalue.selected = "true";
                            } else {
                                optionvalue.selected = "false";
                            }
                            optModifier.optionGroups.map(optRequire => {
                                optionvalue.IsRequired = optRequire.IsRequired;
                                optionvalue.maxselects = optRequire.maxselects;
                            })
                            optionvalue.lenCheck = optModifier.optionGroups;
                            arr.push(optionvalue);
                        })
                    }
                } else {
                    optionGroup.Modifiers.map(optModifier => {
                        let optionvalue = {};
                        dropdownTitle = optionGroup.Name;
                        nextOptionGroupsInternl.push(optModifier);
                        optionvalue.label = optModifier.MenuItemDetail.Name;
                        optionvalue.value = optModifier.MenuItemDetail.Id;
                        optionvalue.ImagePath = optModifier.MenuItemDetail.ImagePath;
                        optionvalue.ModifierSlugName = optModifier.MenuItemDetail.ModifierSlugName;
                        optionvalue.BaseCalories = optModifier.MenuItemDetail.BaseCalories;
                        optionvalue.Price = optModifier.MenuItemDetail.Price;
                        optionvalue.CalcPrice = optModifier.MenuItemDetail.CalcPrice;
                        optionvalue.ComponentDisplay = optModifier.ComponentDisplay;
                        optionvalue.GroupDisplay = optionGroup.GroupDisplay;
                        if (localMultiSelectIds.includes(optModifier.MenuItemDetail.Id)) {
                            optionvalue.selected = "true";
                        } else {
                            optionvalue.selected = "false";
                        }
                        optModifier.optionGroups.map(optRequire => {
                            optionvalue.IsRequired = optRequire.IsRequired;
                            optionvalue.maxselects = optRequire.maxselects;
                        })
                        optionvalue.lenCheck = optModifier.optionGroups;
                        arr.push(optionvalue);
                    })
                }
                if (modalDropDown && modalDropDown == "modalDropdown") {
                    DropdownDetails.DropDownEntries = arr;
                    DropdownDetails.DropDownName = dropdownTitle;

                } else {
                    this.state.DropdownDetails.DropDownEntries = arr;
                    this.state.DropdownDetails.DropDownName = dropdownTitle;
                }
            })
        }
        return DropdownDetails;
        return this.state.DropdownDetails;
    }

    getCalorieText(BaseCalories) {
        return BaseCalories > 0 ? this.props.CalorieAdds + " " + BaseCalories :
            (BaseCalories < 0 ? this.props.CalorieSubtracts + " " + (-1 * BaseCalories) : "0")
    }
    removeAllNestedChild(selectedObj, arr) {
        selectedObj.map(obj => {
           //console.log("removeAllNestedChild obj --> ", obj, arr)
            if (arr.indexOf(obj.value) > -1) {
                arr.splice(arr.indexOf(obj.value), 1);
                this.props.checkMaxCount(obj.value, null, obj.parentGroupId, 'remove')
                this.props.holdTempSelectedIds('substitute', obj);
                let selectedSubObj = this.props.getAllselectedChildModifiers(this.props.parentModifierId, obj.value, true);
                if (selectedSubObj.length > 0) {
                    this.removeAllNestedChild(selectedSubObj, arr);
                }
            }
        });

        this.props.setlocalMultiSelectIds(arr);
    }
    handleUnselect(option, maxSelect, id) {
        if ((option.ComponentDisplay == 1 && arr.indexOf(option.value) > -1) || option.ComponentDisplay == 4 || option.ComponentDisplay == 2) {
            let arr = JSON.parse(JSON.stringify(this.props.getlocalMultiSelectIds()));
            let selectedObj = this.props.getAllselectedChildModifiers(this.props.parentModifierId, option.value, true);
            if (selectedObj.length > 0) {
                this.removeAllNestedChild(selectedObj, arr);
            }
            if (arr.indexOf(option.value) > -1) {
                let selectItem = {};
                selectItem.value = option.value;
                selectItem.label = option.label;
                selectItem.baseCal = option.BaseCalories;
                selectItem.price = option.CalcPrice;
                selectItem.image = option.ImagePath;
                selectItem.componentDisplay = option.ComponentDisplay;

                selectItem.parentModifierId = this.props.parentModifierId;
                selectItem.parentGroupId = id;
                selectItem.parentOptionGroupId = this.props.selectedoptionGroupId || this.props.parentModifierId;

                arr.splice(arr.indexOf(option.value), 1);
                this.props.checkMaxCount(option.value, null, id, 'remove')
                // use substitute - will not reset when we navigate to nested level
                this.props.holdTempSelectedIds('substitute', selectItem);
            }

            this.props.setlocalMultiSelectIds(arr);

        }
        if (option.ComponentDisplay != 2 && option.ComponentDisplay != 4) this.handleHighlightState(option, option.value, maxSelect, id);
    }
    checkItemIsAdded(modifiers, type) {
        let removeOptionItem;
        let arr = this.props.getlocalMultiSelectIds();
        if ((type == "Remove" || type == "Extra") && modifiers != undefined && modifiers != false) {
            modifiers.map(modifier => {
                if (modifier.MenuItemDetail.Name == type) {
                    removeOptionItem = modifier;
                }
            })
            if (removeOptionItem != undefined && arr.indexOf(removeOptionItem.MenuItemDetail.Id) > -1) {
                return true;
            }
        }
        return false;

    }
    handleSegmented(option, max, parentId, modifiers, type) {
        let arr = JSON.parse(JSON.stringify(this.props.getlocalMultiSelectIds()));
        let selectItem = {};
        selectItem.value = option.value;
        selectItem.label = option.label;
        selectItem.baseCal = option.BaseCalories;
        selectItem.price = option.CalcPrice;
        selectItem.componentDisplay = option.ComponentDisplay;
        selectItem.parentModifierId = this.props.parentModifierId;
        selectItem.parentGroupId = parentId;
        selectItem.parentOptionGroupId = this.props.selectedoptionGroupId || parentId;
        let isExist = arr.indexOf(option.value);
        let extraAlreadySelected = false;
        // Extra is already selected and without unselect when user try to remove
        if (isExist != -1 && modifiers != undefined && this.checkItemIsAdded(modifiers, "Extra") == true && type == "Remove") {
            extraAlreadySelected = true;
            arr.splice(arr.indexOf(option.value), 1);
            this.props.checkMaxCount(option.value, max, parentId, 'remove')
            this.props.holdTempSelectedIds('multi', selectItem);
            this.props.removeSelectedModifiersList({ value: selectItem.value }, null, this.props.parentModifierId)
            modifiers.map(modifier => {
                if (modifier.MenuItemDetail.Name == "Extra") {
                    let select_Item = {};
                    select_Item.value = modifier.MenuItemDetail.Id;
                    select_Item.label = modifier.MenuItemDetail.Name;
                    select_Item.baseCal = modifier.MenuItemDetail.BaseCalories;
                    select_Item.componentDisplay = modifier.ComponentDisplay;
                    select_Item.price = modifier.MenuItemDetail.CalcPrice;
                    select_Item.parentModifierId = this.props.parentModifierId;
                    select_Item.parentGroupId = parentId;
                    select_Item.parentOptionGroupId = this.props.selectedoptionGroupId || option.value;
                    arr.splice(arr.indexOf(select_Item.value), 1);
                    this.props.holdTempSelectedIds('multi', select_Item);
                    this.props.removeSelectedModifiersList({ value: select_Item.value }, null, this.props.parentModifierId)
                }
            })
        }

        let cnt = 0;
        if (arr.indexOf(option.value) < 0 || extraAlreadySelected == true) {
            if (this.props.checkMaxCount(option.value, max, parentId, 'add')) {
                cnt = 1;
                arr.push(option.value);
                this.props.holdTempSelectedIds("multi", selectItem);
                this.props.setSelectedModifiersList(selectItem, this.props.parentModifierId);
                if (modifiers) {
                    let removeOptionItem;
                    modifiers.map(modifier => {
                        if (modifier.MenuItemDetail.Name == type) {
                            removeOptionItem = modifier;
                        }
                    })
                    let select_Item = {};
                    select_Item.value = removeOptionItem.MenuItemDetail.Id;
                    select_Item.label = removeOptionItem.MenuItemDetail.Name;
                    select_Item.baseCal = removeOptionItem.MenuItemDetail.BaseCalories;
                    select_Item.price = removeOptionItem.MenuItemDetail.CalcPrice;
                    select_Item.componentDisplay = removeOptionItem.ComponentDisplay;
                    select_Item.parentModifierId = this.props.parentModifierId;
                    select_Item.parentGroupId = parentId;
                    select_Item.parentOptionGroupId = this.props.selectedoptionGroupId || option.value;

                    arr.push(removeOptionItem.MenuItemDetail.Id);
                    this.props.holdTempSelectedIds("multi", select_Item);
                    this.props.setSelectedModifiersList(select_Item, this.props.parentModifierId);
                }
            }
        } else {
            cnt = 1;
            arr.splice(arr.indexOf(option.value), 1);
            this.props.checkMaxCount(option.value, max, parentId, 'remove')
            this.props.holdTempSelectedIds('multi', selectItem);
            this.props.removeSelectedModifiersList({ value: selectItem.value }, null, this.props.parentModifierId);
            if (modifiers) {
                let removeOptionItem;
                modifiers.map(modifier => {
                    if (modifier.MenuItemDetail.Name == type) {
                        removeOptionItem = modifier;
                    }
                })
                let select_Item = {};
                select_Item.value = removeOptionItem.MenuItemDetail.Id;
                select_Item.label = removeOptionItem.MenuItemDetail.Name;
                select_Item.baseCal = removeOptionItem.MenuItemDetail.BaseCalories;
                select_Item.price = removeOptionItem.MenuItemDetail.CalcPrice;
                select_Item.componentDisplay = removeOptionItem.ComponentDisplay;
                select_Item.parentModifierId = this.props.parentModifierId;
                select_Item.parentGroupId = parentId;
                select_Item.parentOptionGroupId = this.props.selectedoptionGroupId || option.value;

                arr.splice(arr.indexOf(select_Item.value), 1);
                this.props.checkMaxCount(select_Item.value, max, parentId, 'remove')
                this.props.holdTempSelectedIds('multi', select_Item);
                this.props.removeSelectedModifiersList({ value: select_Item.value }, null, this.props.parentModifierId);
            }

        }
        if (cnt == 1) {
            this.props.setlocalMultiSelectIds(arr);
        }
    }

    handleHighlightState(option, value, max, parentId) {
        let showDisplaEle = document.getElementById(value + "-checkClick");
        let highliterElement = document.querySelectorAll('#accordionExample1 .multiSelect-body.accordion-body.highlighter');
        let count = highliterElement.length;
        let alreadySelected = false;
        for (let i = 0; highliterElement && i <= highliterElement.length - 1; i++) {
            if (value == highliterElement[i].id) {
                alreadySelected = true;
                break;
            }
        }
        if (!alreadySelected && max != null && count >= max) {
            $(".btnsWrapper .pdp-error-display.alert-dismissible").removeClass("hidden").show().children('.alert-message').text(this.props.allData.MaxSelection);
        } else {
            if (showDisplaEle != null && this.props.checkMaxCount(value, max, parentId, 'add', 'multi')) {
                if (showDisplaEle.classList.contains('firstClick')) {
                    showDisplaEle.classList.remove("show");
                    showDisplaEle.classList.add("hideCheckClick");
                    showDisplaEle.classList.remove("firstClick");
                    //document.getElementById(value + "-checkClick").parentElement.parentElement.parentElement.classList.remove("selectedDiv");
                    document.getElementById(value + "-checkClick").parentElement.parentElement.parentElement.classList.remove("highlighter");

                    this.props.checkMaxCount(value, max, parentId, 'remove', 'multi');
                } else {
                    showDisplaEle.classList.add("show");
                    showDisplaEle.classList.remove("hideCheckClick");
                    showDisplaEle.classList.add("firstClick");
                    document.getElementById(value + "-checkClick").parentElement.parentElement.parentElement.classList.add("highlighter");

                }
            } else {
                $(".btnsWrapper .pdp-error-display.alert-dismissible").removeClass("hidden").show().children('.alert-message').text(this.props.allData.MaxSelection);
            }
        }
    }

    getSideProductImage(option) {
        let image = option.ImagePath;
        let altname = option.ModifierSlugName;
        let localIds = this.props.getlocalMultiSelectIds();
        let count = 0;
        if (option.ComponentDisplay == 6 || option.ComponentDisplay == 7 || option.ComponentDisplay == 4) {
            let selectedObj = this.getLocallySelectedChildren(option.value);
            selectedObj.map(obj => {
                //if (localIds.indexOf(obj.value) != -1) {
                if (obj.value != option.value && count == 0) {
                    count++;
                    image = obj.image;
                    altname = obj.label;
                }
                // }
            })

        }
        return {
            "image": image,
            "altname": altname
        }
    }

    render() {
        const { data, title, id, maxSelect, allData } = this.props;
        this.state.localMultiSelectIds = this.props.getlocalMultiSelectIds();
        let localMultiSelectIds = this.state.localMultiSelectIds;
        let reqiuredText = this.getReqiuredStatus(title);
        let reqClass = " optional ";
        let collapseClas = "";
        if (title.IsRequired == true) reqClass = "required";

        collapseClas = (title.IsRequired == true) ? " show " : " ";

        let titleClass = "";
        // Hide accordion title for side and 4 component
        let isButtonExpand = title.IsRequired;
        if (this.props.displayCompNum == 4 || this.props.displayCompNum == 61 || this.props.displayCompNum == 6 || this.props.displayCompNum == 7) {
            titleClass = " d-none";
            collapseClas = " show ";
        }
        if (id == this.props.selectedCategory) {
            isButtonExpand = true;
            collapseClas = " show ";
        }
        return (
            title.GroupDisplay == 0 ?

                <div className="multiSelect-wrapper accordion" id="accordionExample1">

                    <div className={"accordion-item " + titleClass}>
                        <h5 className="accordion-header titleT">
                            <button className={"accordion-button " + reqClass} data-option-title={title.name} type="button" data-bs-toggle="collapse" data-bs-target={"#accordion-" + id} aria-expanded={isButtonExpand} aria-controls={"accordion-" + id}>
                                {title.name}
                                <p className={"p2 " + reqiuredText.className} data-group-name={title.Name}> ({reqiuredText.text})</p>
                            </button>
                        </h5>
                    </div>

                    {data.map((option) => {

                        let cumulativePrice = this.getAllSelectedChildPrice(option.value, option.CalcPrice, option.ComponentDisplay);
                        let productSideImage = this.getSideProductImage(option);
                        let extraPrice = "$0.00";
                        if (option.ComponentDisplay == 5 && option.optionGroups[0] != undefined) {
                            extraPrice = this.getExtraPrice(option.optionGroups[0].Modifiers);
                        }
                        return (

                            <div id={"accordion-" + id} className={"accordion-collapse collapse " + collapseClas + id} aria-labelledby={option.label} >
                                <div id={"multi-" + option.value} className={this.getTileClass(option)} onClick={() => this.handleTileClick(option, maxSelect, id)} tabIndex="0">
                                    {(productSideImage.image != "none" && productSideImage.image != undefined) &&
                                        <img className="ModifierImg" src={productSideImage.image}
                                            onError={(e) => {
                                                this.handleImageError(e)
                                            }}
                                            alt={productSideImage.altname} />}
                                    <div className="ModifierDesc">
                                        <div className="leftDesc">
                                            <p className="p2 ellipsisText">
                                                {this.getOptionName(option.ModifierSlugName, option.ComponentDisplay, option.value, option.label)}</p>
                                            <p className="small-text accDetail ellipsisText">
                                                {this.getSubOptionName(option.value, option.label, option.ComponentDisplay)}
                                            </p>


                                            {(option.ComponentDisplay != 8 && option.ComponentDisplay != 7) || (option.ComponentDisplay == 7 && localMultiSelectIds.indexOf(option.value) > -1) ?
                                                <p className="p2">
                                                    
                                                    {(cumulativePrice != "$0.00") && <span className="addPrice small-text">+ {cumulativePrice}</span>}
                                                    {option.ComponentDisplay == 5 ?
                                                        <span className="small-text accDetail" id={"extraAdd-" + option.value} tabindex="0" aria-label={option.BaseCalories}>
                                                            {option.optionGroups[0] != undefined ? this.props.getCaloriesDetails(option.optionGroups[0].Modifiers, localMultiSelectIds) : ""}
                                                        </span> :
                                                        (option.ComponentDisplay == 7 || option.ComponentDisplay == 6) ?
                                                            <span className="small-text"> {this.getAllSelectedChildCalories(option.value, option.BaseCalories, option.ComponentDisplay)}</span>
                                                            :
                                                            option.BaseCalories != null && option.BaseCalories != "" ?
                                                                <span className="small-text"> {this.getCalorieText(option.BaseCalories)}&nbsp;{this.props.CalorieAbbr}</span>
                                                                : ""
                                                    }
                                                </p> : <p className="p2">
                                                    {(option.BaseCalories != null && option.BaseCalories != "") && localMultiSelectIds.indexOf(option.value) > -1 ?
                                                        <span className="small-text"> {this.getCalorieText(option.BaseCalories)}&nbsp;{this.props.CalorieAbbr}</span> :
                                                        ""}
                                                </p>
                                            }
                                        </div>
                                    </div>
                                    {(option.ComponentDisplay == 2 || option.ComponentDisplay == 4 || option.ComponentDisplay == 7) ?
                                        <div className="modifierCust btn-lg-text form-check applebees-checkbox" tabindex="0">
                                            {option.ComponentDisplay == 2 && <div id={option.value + "-checkClick"} display="gt"></div>}

                                            {option.ComponentDisplay == 7 && <input className="rounded-circle form-check-input" type="radio" aria-label="Radio" />}
                                            {(option.ComponentDisplay == 4 && !this.checkAnyChildIsSelected(option.optionGroups)) &&
                                                <div id={option.value + "-checkClick"} className="show firstClick"><i className="bi bi-plus"></i></div>
                                            }
                                            {(option.ComponentDisplay == 4 && this.checkAnyChildIsSelected(option.optionGroups)) &&
                                                <div><input className="rounded-circle form-check-input" type="radio" aria-label="Radio" /><label for="radioButton" className="d-none" aria-label="Radio">Radio Button</label></div>}

                                        </div>
                                        :
                                        <div className="modifierCust btn-lg-text form-check applebees-checkbox" tabindex={(option.ComponentDisplay == 2 || option.ComponentDisplay == 6) ? 0 : "-1"}
                                            onClick={(e) => { if (option.ComponentDisplay != 1) { this.handleIconClick(option, maxSelect, id); e.stopPropagation(); } }}>
                                            {option.ComponentDisplay != 0 && !this.checkAnyChildIsSelected(option.optionGroups) ?
                                                (<div>

                                                    {(option.ComponentDisplay == 1)
                                                        && <div id={option.value + "-checkClick"} className="customIng" tabIndex="0" onClick={(e) => { this.handleIconClick(option, maxSelect, id); e.stopPropagation(); }}><u>{allData.CustomizeButtonText}</u></div>}

                                                    {(option.ComponentDisplay == 4) &&
                                                        <div id={option.value + "-checkClick"} className="hideCheckClick"><i className="bi bi-plus"></i></div>}
                                                    {((option.ComponentDisplay == 8 && (localMultiSelectIds.indexOf(option.value) < 0)) || (option.ComponentDisplay == 3 && (localMultiSelectIds && localMultiSelectIds.indexOf(option.value) > -1))) &&
                                                        <div><input className="rounded-circle form-check-input" type="radio" aria-label="Radio" /><label for="radioButton" className="d-none" aria-label="Radio">Radio Button</label></div>}
                                                    {option.ComponentDisplay == 5 &&
                                                        <div className="customIng" ><input className="rounded-circle form-check-input" type="radio" aria-label="Radio" /><label for="radioButton" className="d-none" aria-label="Radio">Radio Button</label></div>}
                                                    {option.ComponentDisplay == 7 &&
                                                        <div className=""><input className="rounded-circle form-check-input" type="radio" aria-label="Radio" /><label for="radioButton" className="d-none" aria-label="Radio">Radio Button</label></div>}
                                                    {(option.ComponentDisplay == 6)
                                                        && <div id={option.value + "-checkClick"} className="show test1"><u>Select</u></div>}
                                                    {((option.ComponentDisplay != 6) && (option.ComponentDisplay != 8) && (option.ComponentDisplay != 1) && (option.ComponentDisplay != 2) && (localMultiSelectIds.indexOf(option.value) > 0)) &&
                                                        <div><input className="rounded-circle form-check-input" type="radio" aria-label="Radio" /><label className="d-none" aria-label="Radio">Radio Button</label></div>}
                                                </div>
                                                )
                                                : option.ComponentDisplay != 0 && this.checkAnyChildIsSelected(option.optionGroups) ?
                                                    (<div>
                                                        {(option.ComponentDisplay == 1) &&
                                                            <div id={option.value + "-checkClick"} className="show firstClick customIng" onClick={(e) => { this.handleIconClick(option, maxSelect, id); e.stopPropagation(); }}><u>{allData.CustomizeButtonText}</u></div>}
                                                        {(option.ComponentDisplay == 4) &&
                                                            <div id={option.value + "-checkClick"} className="show firstClick"><i className="bi bi-plus"></i></div>}
                                                        {((option.ComponentDisplay == 8 && (localMultiSelectIds.indexOf(option.value) < 0)) || (option.ComponentDisplay == 3 && (localMultiSelectIds && localMultiSelectIds.indexOf(option.value) > -1))) &&
                                                            <div><input className="rounded-circle form-check-input" type="radio" aria-label="Radio" /><label className="d-none" aria-label="Radio">Radio Button</label></div>}
                                                        {option.ComponentDisplay == 5 &&
                                                            <div className="customIng" ><input className="rounded-circle form-check-input" type="radio" aria-label="Radio" /><label for="radioButton" className="d-none" aria-label="Radio">Radio Button</label></div>}
                                                        {(option.ComponentDisplay == 6)
                                                            && <div id={option.value + "-checkClick"} className="show customIng firstClick test2"><u>{allData.ChangeText}</u></div>}
                                                        {((option.ComponentDisplay != 6)
                                                            && (option.ComponentDisplay != 5) && (option.ComponentDisplay != 1)
                                                            && (option.ComponentDisplay != 2) && (option.ComponentDisplay != 8)
                                                            && (localMultiSelectIds.indexOf(option.value) > 0)) &&
                                                            <div><input className="rounded-circle form-check-input" type="radio" aria-label="Radio" /><label className="d-none" aria-label="Radio">Radio Button</label></div>}
                                                    </div>
                                                    )
                                                    : (option.ComponentDisplay == 0 && localMultiSelectIds && localMultiSelectIds.indexOf(option.value) > -1) ?
                                                        <div><input className="rounded-circle form-check-input" type="radio" aria-label="Radio" /><label for="radioButton" className="d-none" aria-label="Radio">Radio Button</label></div> : ""
                                            }

                                        </div>
                                    }
                                    {(option.ComponentDisplay == 3 && (localMultiSelectIds && localMultiSelectIds.indexOf(option.value) > -1) && this.filterDropDownInOption(option.optionGroups)) ?
                                        <div className="pdp-dropdown-wrapper pdp-dropdown-option">
                                            <PdpDropdownModal data={this.state.DropdownDetails}
                                                holdTempSelectedIds={(e, label, ids) => this.props.holdTempSelectedIds(e, label, ids)}
                                                updateTotalPrice={(price, action, id) => this.props.updateTotalPrice(price, action, id)}
                                                parentModifierId={this.props.parentModifierId}
                                                removeSelectedModifiersList={(obj, type, mid) => this.props.removeSelectedModifiersList(obj, type, mid)}
                                                setSelectedModifiersList={(obj) => this.props.setSelectedModifiersList(obj)}
                                                parentID={option.value}
                                                setlocalMultiSelectIds={(arr) => this.props.setlocalMultiSelectIds(arr)}
                                                getlocalMultiSelectIds={() => this.props.getlocalMultiSelectIds()}
                                                fromModal={true}
                                                isSteakTempComp={true}
                                                selectedModifiers={this.props.getlocalMultiSelectIds()}
                                                errMsg={allData.RequiredSelection}
                                            />
                                        </div>
                                        : ""}
                                    {option.ComponentDisplay == 7 &&
                                        <div className="pdp-substitute-wrapper">
                                            <span className="p2 bold">{allData.SubstituteTitle}</span>
                                            <span className="p2">{allData.SubstituteDescription}</span>
                                            <span id={option.value + "-checkClick"} className="btn btn-text  show customIng " onClick={(e) => { this.handleSubChange(option, maxSelect, id); e.stopPropagation(); }} tabIndex="0">{this.getSubstituteOptionGroupName(option.optionGroups)}</span>

                                        </div>
                                    }

                                    {option.ComponentDisplay == 5 && option.optionGroups[0] != undefined ?
                                        <div className="hrseparator" >
                                            <div id={option.value + "-checkClick"} tabIndex="0"
                                                onClick={(e) => { this.handleSegmented(option, maxSelect, id, option.optionGroups[0].Modifiers, "Extra"); e.stopPropagation(); }}
                                                className={(this.checkItemIsAdded(option.optionGroups[0].Modifiers, "Extra") == true) ? "extraAdded extraClick" : " extraClick"} display="extra">
                                                <span className="extra-added">{allData.ExtraaddedText} {(extraPrice != "$0.00") && "+" + extraPrice}</span>
                                                <span className="add-extra">{allData.AddextraText} {(extraPrice != "$0.00") && "+" + extraPrice}</span>


                                            </div></div>
                                        : ""}
                                </div>
                            </div>
                        )
                    })}
                </div>
                :
                <div className="multiSelect-wrapper accordion dropdownTest" id="accordionExample1">
                    <div className={"accordion-item " + titleClass}>
                        <h5 className="accordion-header titleT">
                            <button className={"accordion-button " + reqClass} data-option-title={title.name} type="button" data-bs-toggle="collapse" data-bs-target={"#accordion-" + id} aria-expanded={isButtonExpand} aria-controls={"accordion-" + id}>
                                {title.name}
                                <p className={"p2 " + reqiuredText.className} data-group-name={title.Name}> ({reqiuredText.text})</p>
                            </button>
                        </h5>
                    </div>
                    {
                        <div id={"accordion-" + id} className={"accordion-body accordion-collapse collapse " + collapseClas + id} aria-labelledby={title.name} >
                            {/*//dropdown list view // "Don't delete"*/}
                           <div className="pdp-dropdown-wrapper">
                                <PdpDropdownGroupModal data={this.filterDropDownInOption(this.props.optGrp, "modalDropdown")}
                                        holdTempSelectedIds={(e, label, ids) => this.props.holdTempSelectedIds(e, label, ids)}
                                        id={id} reqdStatus={this.props.optGrp.IsRequired}
                                        updateTotalPrice={(price, action, id) => this.props.updateTotalPrice(price, action, id)}
                                        selectedModifiers={this.props.selectedModifiers}
                                        setlocalMultiSelectIds={(arr) => this.props.setlocalMultiSelectIds(arr)}
                                        getlocalMultiSelectIds={() => this.props.getlocalMultiSelectIds()}
                                        removeSelectedModifiersList={(obj, type, mid) => this.props.removeSelectedModifiersList(obj, type, mid)}
                                        setSelectedModifiersList={(obj) => this.props.setSelectedModifiersList(obj)}
                                        idMaps={this.props.idMaps}
                                        parentModifierId={this.props.parentModifierId}
                                        selectedoptionGroupId={this.props.selectedoptionGroupId}
                                        errMsg={this.props.allData.RequiredSelection}
                                        fromModal={true}
                                    />
                           </div>
                            {/*//normal dropdown view // "Don't delete"
                            <div className="pdp-dropdown-wrapper pdp-dropdown-option">
                                <PdpDropdownModal data={this.filterDropDownInOption(this.props.optGrp, "modalDropdown")}
                                    holdTempSelectedIds={(e, label, ids) => this.props.holdTempSelectedIds(e, label, ids)}
                                    id={id}
                                    reqdStatus={this.props.optGrp.IsRequired}
                                    updateTotalPrice={(price, action, id) => this.props.updateTotalPrice(price, action, id)}
                                    selectedModifiers={this.props.selectedModifiers}
                                    setlocalMultiSelectIds={(arr) => this.props.setlocalMultiSelectIds(arr)}
                                    getlocalMultiSelectIds={() => this.props.getlocalMultiSelectIds()}
                                    removeSelectedModifiersList={(obj, type, mid) => this.props.removeSelectedModifiersList(obj, type, mid)}
                                    setSelectedModifiersList={(obj) => this.props.setSelectedModifiersList(obj)}
                                    idMaps={this.props.idMaps}
                                    errMsg={this.props.allData.RequiredSelection}
                                    parentModifierId={this.props.parentModifierId}
                                    selectedoptionGroupId={this.props.selectedoptionGroupId}
                                    fromModal={true}
                                />
                            </div>*/}
                        </div>
                    }

                </div>
        )
    }
}
